import { Component, Input } from '@angular/core';
import { cardHeaderStyles, CardHeaderProps } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-card-header',
  template: `
    <div [ngClass]="cardHeader">
      <kite-stack 
        [align]="align"
        [direction]="direction"
        [spacing]="spacing"
        [justify]="justify"
      >
        <ng-content></ng-content>
      </kite-stack>
    </div>
  `,
})
export class CardHeaderComponent {

  /**
   * Css del componente
   */
   @Input() css: CardHeaderProps['css'];
   /**
    * Alineación de flexbox
    */
   @Input() align: CardHeaderProps['align'];
   /**
    * Dirección de flexbox
    */
   @Input() direction: CardHeaderProps['direction'];
   /**
    * Espaciado entre componentes
    */
   @Input() spacing: CardHeaderProps['spacing'];
 
   /**
    * Justify entre componentes
    */
   @Input() justify: CardHeaderProps['justify'] = 'space-between';

  public get cardHeader(): string[] {
    return [
      cardHeaderStyles({ css: this.css }).className,
    ];
  }
}